export default __webpack_public_path__ + "static/media/serenissima.89ca4e54.jpg";